import { useMatches } from '@remix-run/react'

export type PageHandle = {
  bodyClassName?: string
  hydrate?: boolean
}

export const usePageHandle = () => {
  const matches = useMatches()
  const lastRoute = matches[matches.length - 1]
  const pageHandle = (lastRoute?.handle ?? {}) as PageHandle
  return {
    hydrate: true,
    ...pageHandle,
  }
}
